/** My Courses page — displays the learner's enrolled course portfolio. */
import { useMyEnrolments } from '@/shared/api/hooks';
import { PageContainer } from '@/interfaces/learner/ui';
import CoursePortfolio from './CoursePortfolio';

export default function MyCoursesPage() {
  const { data: enrolments, isLoading } = useMyEnrolments({ staleTime: 0 });

  if (isLoading) return null;

  return (
    <PageContainer className="relative pb-24" style={{ fontFamily: 'var(--font-sans)' }}>
      <div style={{ paddingTop: 'var(--page-top-spacing)' }}>
        <CoursePortfolio enrolments={enrolments ?? []} />
      </div>
    </PageContainer>
  );
}
